/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Document_IncompleteInputs */

const en_error_crm_document_incomplete = /** @type {(inputs: Error_Crm_Document_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some pages are still missing. Upload the PDF again.`)
};

/**
* | output |
* | --- |
* | "Some pages are still missing. Upload the PDF again." |
*
* @param {Error_Crm_Document_IncompleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_document_incomplete = /** @type {((inputs?: Error_Crm_Document_IncompleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Document_IncompleteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_document_incomplete(inputs)
});